<template>
  <div>
    <div class="contact-container">
      <div class="contact-form">
        <div class="contact-form-header">
          <h1 class="text-gradient">{{ $t('contact.header.title') }}</h1>
          <span>{{ $t('contact.header.description') }}</span>
        </div>

        <div class="form-two">
          <div class="column part">
            <label for="firstName">{{ $t('contact.form.firstName.label') }}</label>
            <input
              type="text"
              v-model="firstName"
              :placeholder="$t('contact.form.firstName.placeholder')"
            />
          </div>
          <div class="column part">
            <label for="lastName">{{ $t('contact.form.lastName.label') }}</label>
            <input
              type="text"
              v-model="lastName"
              :placeholder="$t('contact.form.lastName.placeholder')"
            />
          </div>
        </div>

        <div class="form-one">
          <div class="column">
            <label for="companyName">{{ $t('contact.form.companyName.label') }}</label>
            <input
              type="text"
              v-model="companyName"
              :placeholder="$t('contact.form.companyName.placeholder')"
            />
          </div>
        </div>

        <div class="form-one">
          <div class="column">
            <label for="email">{{ $t('contact.form.email.label') }}</label>
            <input
              type="email"
              v-model="email"
              :placeholder="$t('contact.form.email.placeholder')"
            />
          </div>
        </div>

        <div class="form-phone column">
          <label for="phone-number">{{ $t('contact.form.phone.label') }}</label>
          <div class="numbers">
            <select class="fijo" v-model="selectedCountryCode">
              <option v-for="(country, index) in countries" :key="index" :value="country.code">
                ({{ country.code }}) {{ country.name }}
              </option>
            </select>
            <input
              type="number"
              v-model="phoneNumber"
              :placeholder="$t('contact.form.phone.placeholder')"
              style="width: -webkit-fill-available"
            />
          </div>
        </div>

        <div class="column">
          <label for="message">{{ $t('contact.form.message.label') }}</label>
          <textarea
            v-model="message"
            name="message"
            id="message"
            rows="2"
            :placeholder="$t('contact.form.message.placeholder')"
          ></textarea>
        </div>
        <div class="column">
          <a
            class="link"
            href="../../public/Política de Tratamiento de Datos Personales.pdf"
            target="_blank"
          >
            Al enviar tu mensaje aceptas nuestra politica de tratamiento de datos
          </a>
        </div>

        <button class="send" @click="confirmSendEmail">{{ $t('contact.form.button') }}</button>
      </div>
      <div class="contact-image"></div>
    </div>
    <!-- Confirmacion Modal -->
    <div v-if="showConfirmation" class="modal-overlay">
      <div class="modal">
        <h2>{{ $t('contact.modal.confirmation.title') }}</h2>
        <p style="padding: 20px 0px">{{ $t('contact.modal.confirmation.message') }}</p>
        <hr />
        <div class="reverse-buttons">
          <button style="margin: 20px 10px 0px" @click="sendEmail" class="modal-button confirm">
            Sí, Enviar
          </button>
          <button @click="showConfirmation = false" class="modal-button cancel">Cancelar</button>
        </div>
      </div>
    </div>
    <!-- Success Modal -->
    <div v-if="showSuccess" class="modal-overlay">
      <div class="modal">
        <h2>{{ $t('contact.modal.success.title') }}</h2>
        <p>{{ $t('contact.modal.success.message') }}</p>
        <button @click="showSuccess = false" class="modal-button success">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import emailjs from 'emailjs-com'

export default {
  data() {
    return {
      selectedCountryCode: '+57',
      phoneNumber: '',
      firstName: '',
      lastName: '',
      companyName: '',
      email: '',
      message: '',
      countries: [
        { name: 'Colombia', code: '+57' },
        { name: 'United States', code: '+1' },
        { name: 'Mexico', code: '+52' },
        { name: 'Argentina', code: '+54' },
        { name: 'Brazil', code: '+55' },
        { name: 'Canada', code: '+1' },
        { name: 'Germany', code: '+49' },
        { name: 'Spain', code: '+34' },
        { name: 'France', code: '+33' },
        { name: 'United Kingdom', code: '+44' },
        { name: 'Japan', code: '+81' },
        { name: 'South Korea', code: '+82' },
        { name: 'China', code: '+86' },
        { name: 'India', code: '+91' },
        { name: 'Australia', code: '+61' },
      ],
      showConfirmation: false,
      showSuccess: false,
      errorMessage: '',
    }
  },
  methods: {
    confirmSendEmail() {
      if (
        !this.firstName ||
        !this.lastName ||
        !this.companyName ||
        !this.email ||
        !this.message ||
        !this.phoneNumber
      ) {
        this.errorMessage =
          'Todos los campos son obligatorios. Por favor, complete todos los campos.'
        return
      }

      this.showConfirmation = true
    },
    sendEmail() {
      const templateParams = {
        from_name: this.firstName + ' ' + this.lastName,
        company_name: this.companyName,
        email: this.email,
        phone: this.selectedCountryCode + this.phoneNumber,
        message: this.message,
        to_name: 'Equipo de Fourin SAS',
      }

      emailjs
        .send('service_tkqnm5n', 'template_6o6m1up', templateParams, 'oJL34m4tzoxFE6Wtr')
        .then((response) => {
          console.log('Email sent successfully', response)
          this.showConfirmation = false
          this.showSuccess = true
          this.errorMessage = ''
        })
        .catch((error) => {
          console.error('Failed to send email', error)
          this.showConfirmation = false
          this.errorMessage = 'Ocurrió un error al enviar el mensaje. Inténtalo nuevamente.' // Mensaje de error si algo falla
        })
    },
  },
}
</script>

<style scoped>
.link {
  color: gray;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal h2 {
  color: #333;
  font-size: 20px;
}

.modal p {
  color: #666;
  font-size: 16px;
}

.modal-button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  margin-top: 20px;
  font-size: 16px;
  cursor: pointer;
}

.confirm {
  background-color: #28a745;
  color: #fff;
}

.cancel {
  background-color: #dc3545;
  color: #fff;
}

.success {
  background-color: #007bff;
  color: #fff;
}
</style>

<style>
.fijo {
  width: 120px;
  padding: 0.5em;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.numbers {
  display: flex;
  gap: 10px;
  align-items: center;
}

label {
  font-weight: 600;
}

.part {
  width: 49%;
}
input {
  height: 42px;
  font-size: 18px;
  font-weight: 300;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  padding: 0px 12px;
}

textarea {
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  padding: 25px 25px;
  font-size: 18px;
  font-weight: 300;
}
.send {
  background: #1297ef;
  color: white;
  height: 45px;
  width: 100%;
  margin: 10px 0px;
  border: none;
  border-radius: 6px;
  font-size: 17px;
  cursor: pointer;
  transition: 150ms linear;
}
.reverse-buttons {
  display: flex;
  justify-content: flex-start;
  flex-direction: row-reverse;
}
.send:hover {
  transform: scale(1.023);
  background: #0d69a7;
  box-shadow: 1px 1px 10px #0003;
}
.contact-container {
  display: flex;
    padding: 3em;
    max-width: 1400px;
    margin: 20px auto
}
.contact-form {
  padding: 3em 2em 0px;
  background: #f9f9f9;
  border-radius: 10px;
  margin: 0px 2em 0px 0px;
  width: 70%;
}

.text-gradient {
  background: linear-gradient(90deg, #1297ef 22%, #0a5789 100%);
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.contact-image {
  background-image: url(../assets/images/contact.png);
  background-size: cover;
  background-position: center;
  width: 65%;
  height: 700px;
  border-radius: 10px;
}

.form-two {
  display: flex;
  justify-content: space-around;
}
.contact-form-header h1 {
  font-size: 37px;
  font-weight: 600;
}

.contact-form-header span {
  font-size: 20px;
  line-height: 100%;
  font-weight: 300;
  color: #6c6c6c;
}

.column {
  display: flex;
  margin: 10px 0px 0px;
  flex-direction: column;
}

@media (width < 768px) {
  .contact-container {
    display: flex;
    padding: 1em;
  }
  .contact-image {
    display: none;
  }
  .contact-form {
    padding: 3em 1em 0px;
    background: #f9f9f9;
    border-radius: 10px;
    width: auto;
    margin: 0px;
  }

  .form-two {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  }

  .part {
    width: auto;
  }
  .numbers {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    flex-direction: column;
  }
  .contact-container {
    display: flex;
    padding: 1em;
    flex-direction: column;
  }
}
</style>
